import { render } from "./ApolloGraphQL.vue?vue&type=template&id=9312c818"
import script from "./ApolloGraphQL.vue?vue&type=script&lang=js"
export * from "./ApolloGraphQL.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__